import React from 'react';
import MuiButton from '@material-ui/core/Button';

export class Button extends React.Component {

    render() {
        const { disabled, field, loading, type, onClick, id } = this.props;

        return (
            <MuiButton
                variant="contained"
                color={field.color}
                disabled={disabled}
                type={type}
                onClick={onClick}
                id={id}
            >
                {field.text}
            </MuiButton>
        );
    }
}
